goog.provide("shadow.js.shim.module$$carbon$icons_react$es$Copy$default");
shadow.js.shim.module$$carbon$icons_react$es$Copy$default = shadow.js.require(358, {}).default;
